import { createNamedConsumer } from './createNamedConsumer';
import { createNamedContext } from './createNamedContext';
import { createNamedProvider } from './createNamedProvider';
import { createNamedContextHook } from './createNamedContextHook';
export function createHookContext(name, useHook, propsAreEqual) {
    const hookName = `use${name}`;
    const providerName = `${name}Provider`;
    const consumerName = `${name}Consumer`;
    const contextName = `${name}Context`;
    const Context = createNamedContext(contextName);
    const useContext = createNamedContextHook(hookName, Context);
    const Provider = createNamedProvider(Context, useHook, propsAreEqual);
    Provider.displayName = providerName;
    const Consumer = createNamedConsumer(consumerName, useContext);
    return Object.assign([useContext, Provider, Consumer, Context], {
        [hookName]: useContext,
        [providerName]: Provider,
        [consumerName]: Consumer,
        [contextName]: Context,
    });
}
//# sourceMappingURL=createHookContext.js.map